import React from 'react';
import {Modal,Input,Form} from 'antd';
import CopywritingTips from './CopywritingTips';
import styles from './SDKLivenessForm.module.less';
const FormItem = Form.Item;


// props: action，tips

class ItemAction extends React.Component {

    state = {
        isShowTextModal:false
    }
    onCloseTextModal = ()=>{
        // 如果关闭，清理已输入内容
        this.setState({
            isShowTextModal:false
        });

    }

    onSaveText = ()=>{
        this.props.form.validateFields((errors, values)=>{
            if(!errors){
                this.props.onChange(values);
                this.setState({isShowTextModal:false});
            }
        });
    }

    onTipsChange = ()=>{
        this.setState({
            isShowTextModal:true
        });
    }


    render(){
        const {value={},actionMap} = this.props;
        const {getFieldDecorator} = this.props.form;
        const {isShowTextModal} = this.state;
        return (
            <div>
                <div className={styles.tipsTextBg} style={{width:600}}>
                    <div className={styles.tipsTextTop}>
                        <img src={require('image/scene/icon/notice.svg')} /><span>Preview</span>
                        {!this.props.disabled && <a onClick={this.onTipsChange}>Revise</a>}
                    </div>
                    <CopywritingTips />
                    {actionMap.map((item)=>{
                        return <div key={item.key} className={styles.tipsText}>{item.label}：{value[item.key]}</div>;
                    })}
                </div>
                <Modal
                    visible={isShowTextModal}
                    title="Action stage guide copy"
                    onCancel={this.onCloseTextModal}
                    onOk={this.onSaveText}
                    destroyOnClose
                >
                    <CopywritingTips />
                    {actionMap.map((item)=>{
                        return (
                            <FormItem label={item.label} key={item.key}>
                                {getFieldDecorator(item.key,{
                                    initialValue:value[item.key],
                                    rules:[
                                        {required:true,message:'not nullable'},
                                        {max:100,message:'Cannot be greater than 100 characters'}
                                    ]
                                })(
                                    <Input
                                        size="large"
                                    />
                                )}
                            </FormItem>
                        );
                    })}

                </Modal>
            </div>
        );
    }

}
export default Form.create()(ItemAction);



// WEBPACK FOOTER //
// ./src/pages/SDKLiveness/ItemAction.js